var places = {
	el: {
		container: document.querySelector('.form-volunteer'),
		formEdit: document.querySelector('.form-edit'),
		zipFullCode: document.querySelector('.js-zip-code'),
		neighbourhoodInput: document.querySelector('.js-input-neighbourhood'),
		districtsSelect: document.querySelector('.js-select-district'),
		countiesSelect: document.querySelector('.js-select-county'),
		parishsSelect: document.querySelector('.js-select-parish'),
		enableFields: document.querySelector('.js-enable-fields'),
		disabledFields: document.querySelectorAll('.disabled-first')
	},

	vars: {
		xhr: new XMLHttpRequest()
	},

	enableFirstDisabledFields: function enableFirstDisabledFields(el) {
		var numberOfCharacters = el.value.length;
		Array.prototype.slice.call(this.el.disabledFields).forEach(function(el) {
			return numberOfCharacters === 4 ? el.removeAttribute('disabled') : el.setAttribute('disabled', '');
		});
	},

	resetFields: function resetFields(el) {
		var optionReset = new Option(el.dataset.resetOption, '-1', true, true);

		if (el === this.el.districtsSelect) {
			el.removeAttribute('disabled');
			el.selectedIndex = 0;
		}
		else {
			el.options.length = 0;
			el.setAttribute('disabled', '');
			el.add(optionReset);
			optionReset.disabled = true;
			optionReset.hidden = true;
		}

		this.el.neighbourhoodInput.removeAttribute('disabled');
	},

	getFullAddress: function getFullAddress(el) {
		var _this = this;

		var zipFirstPartial = this.el.enableFields.value,
			zipSecondPartial = el.value,
			zipFirstPartialTotal = zipFirstPartial.length,
			zipSecondPartialTotal = zipSecondPartial.length,
			baseEndpoint = el.dataset.action,
			endpoint = "".concat(baseEndpoint, "/").concat(zipFirstPartial, "/").concat(zipSecondPartial);

		if (zipFirstPartialTotal === 4) {
			if (zipSecondPartialTotal === 3) {
				el.classList.add('zipcode-enabled');
				this.vars.xhr.open('GET', endpoint, true);
				this.vars.xhr.send();

				this.vars.xhr.onprogress = function() {
					return el.parentElement.classList.add('is-loading');
				};

				this.vars.xhr.onreadystatechange = function(e) {
					if (e.currentTarget.readyState === 4 && e.currentTarget.status === 200) {
						var data = JSON.parse(_this.vars.xhr.responseText),
							totalParishs = data.freguesias.length,
							defaultOption = new Option(_this.el.parishsSelect.dataset.resetOption, '-1', true, true),
							optionSelectedDistrict = Array.prototype.slice.call(_this.el.districtsSelect.options),
							countySelected = new Option(data.concelho, data.concelho, true, true);
						//remove preloader
						el.parentElement.classList.remove('is-loading');

						//disable/enable necessary fields
						_this.el.parishsSelect.options.length = 0;
						_this.el.countiesSelect.options.length = 0;
						_this.el.neighbourhoodInput.setAttribute('disabled', '');
						_this.el.countiesSelect.setAttribute('disabled', '');
						_this.el.districtsSelect.setAttribute('disabled', '');
						_this.el.parishsSelect.removeAttribute('disabled');

						//set values in fields
						_this.el.neighbourhoodInput.value = data.codigoPostalDesc;
						optionSelectedDistrict.filter(function(el) {
							return el.value === data.distrito ? el.selected = true : '';
						});

						_this.el.countiesSelect.add(countySelected);

						for (var i = -1; i < totalParishs; i++) {
							var options = data.freguesias[i];

							if (i === -1) {
								_this.el.parishsSelect.add(defaultOption);

								defaultOption.disabled = true;
								defaultOption.hidden = true;
							}
							else {
								_this.el.parishsSelect.add(new Option(options));
							}
						}
					}
				};
			}
			else {
				//reset fields
				if (el.classList.contains('zipcode-enabled')) {
					this.el.neighbourhoodInput.value = '';
					this.resetFields(this.el.districtsSelect);
					this.resetFields(this.el.countiesSelect);
					this.resetFields(this.el.parishsSelect);
				}

				el.classList.remove('zipcode-enabled');
			}
		}
	},

	getPartialAddress: function getPartialAddress(el, nextSelect) {
		var _this2 = this;

		var baseEndpoint = el.dataset.action,
			target = el.options[el.selectedIndex].value,
			districtTarget = this.el.districtsSelect.options[this.el.districtsSelect.selectedIndex].value,
			endpoint = nextSelect === this.el.countiesSelect ? "".concat(baseEndpoint, "/").concat(target) : "".concat(baseEndpoint, "/").concat(districtTarget, "/").concat(target),
			defaultOptionText = nextSelect.dataset.resetOption
		defaultOption = new Option(defaultOptionText, '-1', true, true);
		this.vars.xhr.open('GET', endpoint, true);
		this.vars.xhr.send();

		this.vars.xhr.onprogress = function() {
			return nextSelect.parentElement.classList.add('is-loading');
		};

		this.vars.xhr.onreadystatechange = function(e) {
			if (e.currentTarget.readyState === 4 && e.currentTarget.status === 200) {
				var data = JSON.parse(_this2.vars.xhr.responseText),
					totalData = data.length;

				//remove preloader	
				nextSelect.parentElement.classList.remove('is-loading');

				//reset parish on 2nd plus click in districts
				if (el === _this2.el.districtsSelect && !nextSelect.disabled) {
					_this2.resetFields(_this2.el.parishsSelect);
				}
				//enable next select
				nextSelect.removeAttribute('disabled');

				// reset next select
				nextSelect.options.length = 0;

				// set values in fields - next Select
				for (var i = -1; i < totalData; i++) {
					var options = data[i];

					if (i === -1) {
						nextSelect.add(defaultOption);
						defaultOption.disabled = true;
						defaultOption.hidden = true;
					}
					else {
						nextSelect.add(new Option(options));
					}
				}
			}
		};
	},

	events: function events() {
		var _this3 = this;

		//enable zipcode & district (no API)
		this.el.enableFields.addEventListener('keyup', function(e) {
			return _this3.enableFirstDisabledFields(e.currentTarget);
		});

		//get counties
		this.el.districtsSelect.addEventListener('change', function(e) {
			return _this3.getPartialAddress(e.currentTarget, _this3.el.countiesSelect);
		});

		//get parishs
		this.el.countiesSelect.addEventListener('change', function(e) {
			return _this3.getPartialAddress(e.currentTarget, _this3.el.parishsSelect);
		});

		//get full address
		this.el.zipFullCode.addEventListener('keyup', function(e) {
			return _this3.getFullAddress(e.currentTarget);
		});
	},

	init: function init() {
		if (this.el.container || this.el.formEdit)
			this.events();
	}
};
places.init();